<template>
    <div class="list">
        <NavBar></NavBar>
        <van-cell is-link class="cellFix" v-for="item in list" :key="item">
            <template #title >
                <div class="cellFix_title">
                    <i class="iconfont icon-weixinzhifu" style="font-size:36px;color:#04BE02"></i>
                    <!-- <div style="font-size:16px;font-weight:bold;padding-left:15px">123</div> -->
                    <div style="font-size:15px;padding-left:6px">
                        <div style="font-weight:bold">{{item.createuser}}</div>
                        <div style="font-size:13px;color:gray">{{item.chargeabletime.substring(0,19)}}</div>
                    </div>
                </div>
            </template>
            <template #right-icon>
                <!-- <van-icon name="search" class="search-icon" /> -->
                <div style="font-size:13px;font-weight:bold;color:gray">￥{{item.paymentamount}}</div>
            </template>
        </van-cell>
        <van-empty v-if="isShow"   image="error" description="暂无数据" />
        <!-- <van-pagination v-model="currentPage" :total-items="" :show-page-size="3" force-ellipses /> -->
    </div>
</template>

<script>
    import VueCookie from 'vue-cookie'
    export default {
        data() {
            return {
                isShow:false,
                currentPage:'1',
                list:[]
            }
        },
        methods:{
            historyList(){
                let data={
                    openId:VueCookie.get('openId'),
                    pageNum:1,
                    pageSize:10000
                }
                this.$postQuery('/FeePrepaidExpenses/getRechargeRecordList', data).then((response) => {
                    console.log(response)
                    if(response.code==200){
                        if(response.data.list.length==0){
                            this.isShow = true
                        }else{
                            this.isShow = false
                            this.list = response.data.list
                        }
                    }
                })
            }
        },
        created(){
            this.historyList()
        }
    }
</script>

<style scoped>
    .list {
        margin-top: 46px;
    }
    .cellFix{
        display: flex;
        align-items: center;
    }
    .cellFix_title{
        display: flex;
        align-items: center;
    }
</style>